// extracted by mini-css-extract-plugin
export default {"tickColour":"#000","overlay":"SuccessOverlay--overlay--cbe553","container":"SuccessOverlay--container--84f708","message":"SuccessOverlay--message--fd4957"};